/**
 * Deep-clones a JSON-serializable value using `structuredClone` with a JSON fallback.
 *
 * @param value - The value to clone.
 * @returns A clone, or null when the value cannot be serialized.
 */
export function cloneSerializable(value: unknown): unknown {
   if (value === undefined || value === null) {
      return null
   }
   if (typeof value !== 'object') {
      return value
   }
   let structuredCloneFn: typeof structuredClone | null = null
   if (typeof window !== 'undefined' && typeof window.structuredClone === 'function') {
      structuredCloneFn = window.structuredClone
   } else if (typeof structuredClone === 'function') {
      structuredCloneFn = structuredClone
   }
   if (structuredCloneFn) {
      try {
         return structuredCloneFn(value)
      } catch (error) {
         console.warn('structuredClone failed, falling back to JSON clone', error)
      }
   }
   try {
      return JSON.parse(JSON.stringify(value))
   } catch (error) {
      console.error('Failed to serialize data for export', error)
      return null
   }
}
